import AccountDetailsForm from './account-details-form';

export default AccountDetailsForm;
